
import { defineComponent } from '@vue/composition-api';
import icons from './icons.vue';
import SportIcons from './SportIcons.vue';

export default defineComponent({
  name: 'IllinoisCollapsible',
  props: {
    title: {
      type: String,
      default: 'Clicca per espandere'
    },
    initialOpen: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: 'chevron-down',
      required: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isDropdownIconFixed: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconAlwaysWhite: {
      type: Boolean,
      default: false
    },
    stickyHeader: {
      type: Boolean,
      default: false
    }
  },
  components: {
    icons,
    SportIcons
  },
  data() {
    return {
      isOpen: this.initialOpen
    };
  },
  mounted() {
    if (this.initialOpen) {
      this.open();
    }
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('toggle', this.isOpen);
    },

    open() {
      this.isOpen = true;
    }
  }
});
